export const ASSET_CREATE = "ASSET_CREATE";
export const ASSET_IMPORT = "ASSET_IMPORT";
export const ASSET_CREATE_PAGE_LOADED = "ASSET_CREATE_PAGE_LOADED";
export const ASSET_CREATE_PAGE_UNLOADED = "ASSET_CREATE_PAGE_UNLOADED";
export const ASSET_UPDATE = "ASSET_UPDATE";
export const ASSET_UPDATE_PAGE_UNLOADED = "ASSET_UPDATE_PAGE_UNLOADED";
export const ASSET_LIST_PAGE_LOADED = "ASSET_LIST_PAGE_LOADED";
export const ASSET_LIST_PAGE_UNLOADED = "ASSET_LIST_PAGE_UNLOADED";
export const ASSET_DETAIL_PAGE_LOADED = "ASSET_DETAIL_PAGE_LOADED";
export const ASSET_DETAIL_PAGE_UNLOADED = "ASSET_DETAIL_PAGE_UNLOADED";
export const ASSET_ADD_PAGE_LOADED = "ASSET_ADD_PAGE_LOADED";
export const ASSET_ADD_PAGE_UNLOADED = "ASSET_ADD_PAGE_UNLOADED";
export const ASSET_EDIT_PAGE_LOADED = "ASSET_EDIT_PAGE_LOADED";
export const ASSET_EDIT_PAGE_UNLOADED = "ASSET_EDIT_PAGE_UNLOADED";

export const SITE_CREATE = "SITE_CREATE";
export const SITE_UPDATE = "SITE_UPDATE";
export const LOAD_SITE = "LOAD_SITE";
export const SITE_LIST_PAGE_LOADED = "SITE_LIST_PAGE_LOADED";
export const SITE_LIST_PAGE_UNLOADED = "SITE_LIST_PAGE_UNLOADED";
export const SITE_DETAIL_PAGE_LOADED = "SITE_DETAIL_PAGE_LOADED";
export const SITE_DETAIL_PAGE_UNLOADED = "SITE_DETAIL_PAGE_UNLOADED";

export const LOG_EVENT = "LOG_EVENT";
export const EVENT_ADD_PAGE_LOADED = "EVENT_ADD_PAGE_LOADED";
export const EVENT_ADD_PAGE_UNLOADED = "EVENT_ADD_PAGE_UNLOADED";
export const EVENT_DETAIL_PAGE_LOADED = "EVENT_DETAIL_PAGE_LOADED";
export const EVENT_DETAIL_PAGE_UNLOADED = "EVENT_DETAIL_PAGE_UNLOADED";
export const EVENT_LIST_PAGE_LOADED = "EVENT_LIST_PAGE_LOADED";
export const EVENT_LIST_PAGE_UNLOADED = "EVENT_LIST_PAGE_UNLOADED";

export const CAMPAIGN_CREATE = "CAMPAIGN_CREATE";
export const CAMPAIGN_UPDATE = "CAMPAIGN_UPDATE";
export const CAMPAIGN_ADD_PAGE_LOADED = "CAMPAIGN_ADD_PAGE_LOADED";
export const CAMPAIGN_ADD_PAGE_UNLOADED = "CAMPAIGN_ADD_PAGE_UNLOADED";
export const CAMPAIGN_LIST_PAGE_LOADED = "CAMPAIGN_LIST_PAGE_LOADED";
export const CAMPAIGN_LIST_PAGE_UNLOADED = "CAMPAIGN_LIST_PAGE_UNLOADED";
export const CAMPAIGN_DETAIL_PAGE_LOADED = "CAMPAIGN_DETAIL_PAGE_LOADED";
export const CAMPAIGN_DETAIL_PAGE_UNLOADED = "CAMPAIGN_DETAIL_PAGE_UNLOADED";
export const CAMPAIGN_EDIT_PAGE_LOADED = "CAMPAIGN_EDIT_PAGE_LOADED";
export const CAMPAIGN_ITEM_DETAIL_PAGE_LOADED =
  "CAMPAIGN_ITEM_DETAIL_PAGE_LOADED";
export const CAMPAIGN_ITEM_DETAIL_PAGE_UNLOADED =
  "CAMPAIGN_ITEM_DETAIL_PAGE_UNLOADED";

export const BULK_SEND_SMS_VIA_CAMPAIGN = "BULK_SEND_SMS_VIA_CAMPAIGN";
export const SEND_SMS_VIA_CAMPAIGN_ITEM = "SEND_SMS_VIA_CAMPAIGN_ITEM";
export const ADD_CAMPAIGN_ITEM = "ADD_CAMPAIGN_ITEM";
export const REMOVE_CAMPAIGN_ITEM = "REMOVE_CAMPAIGN_ITEM";
export const CAMPAIGN_ITEMS_EDIT_PAGE_LOADED =
  "CAMPAIGN_ITEMS_EDIT_PAGE_LOADED";
export const CAMPAIGN_ITEMS_EDIT_PAGE_UNLOADED =
  "CAMPAIGN_ITEMS_EDIT_PAGE_UNLOADED";
